import {
  getSmartFormList,
  formStartOrEnd,
  setFormRemark,
  copyCodeAddress,
  copyForm,
  deleteForm,
  exportSubmitRecord
} from '@/services/smart'
import { getAuthTeamInfo } from '@/services/index'
import i18n from '@/lib/language'
const formTit = i18n.t('message["717"]').split('|')
const openStopTit = i18n.t('message["1202"]').split('|')
const store = {
  namespaced: true,
  state: {
    loading: false,
    formList: [],
    formType: { 1: formTit[0], 2: formTit[1] },
    formSwitch: { 1: openStopTit[0], 2: openStopTit[1] },
    statusSelect: [
      { value: 3, name: i18n.t('message["904"]') },
      { value: 0, name: i18n.t('message["138"]') },
      { value: 1, name: i18n.t('message["1452"]') },
      { value: 2, name: i18n.t('message["62"]') }
    ],
    formColumns: [
      {
        title: i18n.t('message["57"]'),
        dataIndex: 'name',
        key: 'name',
        scopedSlots: { customRender: 'name' }
      },
      {
        title: i18n.t('message["27"]'),
        dataIndex: 'remark',
        key: 'remark',
        scopedSlots: { customRender: 'remark' }
      },
      {
        title: i18n.t('message["615"]'),
        dataIndex: 'view_times',
        key: 'view_times',
        scopedSlots: { customRender: 'view_times' }
      },
      {
        title: i18n.t('message["1176"]'),
        dataIndex: 'sub_rate',
        key: 'sub_rate',
        scopedSlots: { customRender: 'sub_rate' }
      },
      {
        title: i18n.t('message["1695"]'),
        key: 'post_times',
        dataIndex: 'post_times',
        scopedSlots: { customRender: 'post_times' }
      },
      {
        title: i18n.t('message["549"]'),
        key: 'username',
        dataIndex: 'username',
        scopedSlots: { customRender: 'username' }
      },
      {
        title: i18n.t('message["1682"]'),
        dataIndex: 'uptime',
        key: 'uptime',
        sorter: true,
        scopedSlots: { customRender: 'uptime' }
      },
      {
        title: i18n.t('message["79"]'),
        key: 'action',
        scopedSlots: { customRender: 'action' }
      }
    ],
    pagination: {
      currentPage: 1,
      pageSize: 10,
      pageSizes: [10, 20, 30, 50],
      pageSizesType: { 10: 1, 20: 2, 30: 3, 50: 4 },
      total: 0
    },
    // 开发人员
    developerList: [],
    // 查询条件
    filterForm: { name: '', ids: [] }
  },
  mutations: {
    SET_FORM_LIST (state, list) {
      state.formList = list
    },
    SET_PAGINATION (state, params) {
      const { key, value } = params
      state.pagination = Object.assign(state.pagination, { [key]: value })
    },
    SET_FORM_LIST_INDEX (state, params) {
      const { formid, key, value } = params
      for (let i = 0; i < state.formList.length; i++) {
        let item = state.formList[i]
        if (item.formid === formid) {
          state.formList[i][key] = value
          break
        }
      }
    },
    SET_DEVELOPER_LIST (state, list) {
      list.push({
        id: '+1',
        keyname: 'userid',
        name: '- -'
      })
      state.developerList = list
    },
    SET_FILTER_FORM (state, options) {
      state.filterForm = Object.assign(state.filterForm, options)
    },
    SET_LOADING (state, load) {
      state.loading = load
    }
  },
  actions: {
    // 获取万能表单列表
    async fetchFormList ({ commit, dispatch }, params = {}) {
      commit('SET_LOADING', true)
      const chain = await getSmartFormList()
        .params(params)
        .onSuccess(res => {
          const { count, list } = res
          commit('SET_FORM_LIST', list)
          commit('SET_PAGINATION', { key: 'total', value: Number(count) })
        })
        .onNetComplete(() => {
          commit('SET_LOADING', false)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 获取开发人员
    async getPersonList ({ commit }) {
      const chain = await getAuthTeamInfo()
        .params({ pk: 'inquiry-dev', type: 0, deal: 1, isshowall: 0 })
        .onSuccess(res => {
          commit('SET_DEVELOPER_LIST', res)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 启用|停用表单
    async toFormSwitch ({ commit }, params = {}) {
      const chain = await formStartOrEnd()
        .params(params)
        .config({ tip: false })
      return chain
    },
    // 设置表单备注
    async setRemark ({ commit }, params = {}) {
      const chain = await setFormRemark()
        .params(params)
        .onSuccess(res => {
          const { formid, remark } = params
          commit('SET_FORM_LIST_INDEX', {
            formid,
            key: 'remark',
            value: remark
          })
        })
        .config({ tip: true })
        .fetch()
      return chain
    },
    // 复制代码/地址
    async toCopyData ({ commit }) {
      const chain = await copyCodeAddress().config({ tip: false })
      return chain
    },
    // 复制表单
    async toCopyForm ({ commit }) {
      const chain = await copyForm().config({ tip: false })
      return chain
    },
    // 删除表单
    async delForm ({ commit }) {
      const chain = await deleteForm().config({ tip: true })
      return chain
    },
    // 导出提交记录
    async exportSingleRecord ({ commit }) {
      const chain = await exportSubmitRecord().config({ tip: false })
      return chain
    }
  }
}

export default store
